import AuthenticationService from '@/services/auth.service';
import orangePartnerService from "@/services/partners/orange";
import { isObj, isUndef } from '@/utils';

const userToken = localStorage.getItem('kidj_ut');
const partnerToken = localStorage.getItem('kidj_pt');

const state = {
  token: userToken,
  isPremium: false,
  authenticated: false,
  id: '',
  userName: '',
  isEmailFake: false,
  isPromoAccepted: false,
  isTcAccepted: true,
  partner: {
    name: null,
    token: partnerToken ? partnerToken : false,
  },
  subscriptionId: null,
  operationId: null,
  storeId: null
};

const actions = {
  checkUserKey({ dispatch }, key) {
    return AuthenticationService.verifyKey(key)
      .then((response) => {
        dispatch('setToken', response.data?.token);
        return Promise.resolve(response.data.token)
      }).catch((error) => {
        return Promise.reject
      });
  },

  getUserInfo({ commit }, payload) {
    return AuthenticationService.getUserInfo(payload || localStorage.getItem('kidj_ut'))
      .then((response) => {
        if (response.status === 200) {
          commit('SetUserAntheticated', true);
          commit('SaveUserName', response.data.user.name);
          commit('SaveUserId', response.data.user.id);
          commit('SaveIsEmailFake', response.data.user.isEmailFake);
          commit('SaveIsPromoAccepted', response.data.user.isPromoAccepted === 1);
          commit('SaveIsTcAccepted', response.data.user.isTcAccepted === 1);
          commit('SetStoreId', response.data.user.subscription.storeId);
          commit('SetSubscriptionId', response.data.user.subscription.id);
          commit('SetPartner', response.data.user.subscription.storeId);
          if (response.data.user.expirationDate) {
            const date = new Date(response.data.user.expirationDate);
            const currentDate = new Date().toUTCString();
            if (Date.parse(currentDate) < Date.parse(date.toUTCString())) {
              commit('SetUserPremium', true);
            }
          }
          return Promise.resolve();
        }
      }).catch(() => {
          commit('SetUserAntheticated', false);
          commit('SetUserPremium', false);
          return Promise.reject();
          // localStorage.removeItem('kidj_ut')
      });
  },

  updateUserConsent({ commit }, data) {
    return AuthenticationService.updateUserConsent(state.token, data)
    .then((response) => {
      if (response.status === 200) {
        commit('SaveIsPromoAccepted', data.isPromoAccepted);
        commit('SaveIsTcAccepted', data.isTcAccepted);
      }
    }).catch(() => {
        commit('SetUserAntheticated', false);
        commit('SetUserPremium', false);
    });
  },


  getUserGenerateKey({ commit }) {
    return AuthenticationService.generateRedirectKey(state.token || localStorage.getItem('kidj_ut'));
  },

  // DEV NOTE: this service will be called when we implement sessions on user session expired
  signUserOut({ dispatch, commit }) {
    return AuthenticationService.signUserOut(state.token)
      .then((response) => {
        if (response.status === 200) {
          dispatch('resetUserToken');
          commit('SetUserAntheticated', false);
          commit('SetUserPremium', false);
        }

        return true;
      },
      (error) => {
        return error.response;
      });
  },

  getOrangeSubscriberData({ dispatch }) {
    return orangePartnerService.getOrangeAlias()
      .then(({ userAlias, error, description }) => {
        if (!isUndef(error)) {
          console.warn(description);
          return error;
        }

        if (!isUndef(userAlias)) {
          AuthenticationService.getSubscriptionList(userAlias)
            .then(({ data }) => {
              dispatch('setOrangeUser', { subscriptions: data.subscriptions, token: userAlias })
            });
        }
      });
  },
  
  getOrangeMoroccoSubscriberData ({ commit, getters }, payload) {
    return orangePartnerService.getPartnerAlias({ name: 'orange', subscriptionId: getters.getSubscriptionId, operationId:
      getters.getOperationId })
      .then((response) => {
        if (response && !isUndef(response.token)) {
          AuthenticationService.getUserInfo(response.token || localStorage.getItem('kidj_ut'))
            .then((response) => {
              if (response.status === 200) {
                commit('SetUserAntheticated', true);
                commit('SaveUserName', response.data.user.name);
                commit('SetStoreId', response.data.user.subscription.storeId);

                if (response.data.user.expirationDate) {
                  const date = new Date(response.data.user.expirationDate);
                  const currentDate = new Date().toUTCString();
                  if (Date.parse(currentDate) < Date.parse(date.toUTCString())) {
                    commit('SetUserPremium', true);
                  }
                }
              }
            }).catch(() => {
                commit('SetUserAntheticated', false);
                commit('SetUserPremium', false);
            });
      }
    }).catch((errorMessage)=>{
      console.warn(errorMessage);
    })
  },

  setOrangeUser({ dispatch, commit }, { subscriptions, token }) {
    const allowedSubTypes = ['kidjo_tv_books', 'kidjo_tv']
    const tvSubscription = subscriptions.find((subscription) => allowedSubTypes.includes(subscription.subscriptionType));
    const isExpiredSubscription = Date.parse(new Date().toUTCString()) > Date.parse(tvSubscription.nextBillingDate)

    if (isObj(tvSubscription) && !isExpiredSubscription) {
      dispatch('setPartner', { token, name: 'orange' })

      commit('SetUserAntheticated', true);
      commit('SaveUserName', 'Orange subscriber');
      commit('SetUserPremium', true);
    }
  },
  setToken({ commit }, token) {
    localStorage.setItem('kidj_ut', token);
    commit('SetUserToken', token);
  },

  resetUserToken({ commit }) {
    localStorage.removeItem('kidj_ut');
    commit('SetUserToken', false);
  },

  setPartner({ commit }, data) {
    localStorage.setItem('kidj_pt', data.token);
    commit('SetPartnerData', data);
  },
  SetPartner({ commit }, data) {
    commit('SetPartner', data);
  },
  setPartnerIntergationInfo({ commit }, { subscriptionId, operationId}) {
    commit('SetSubscriptionId', subscriptionId);
    commit('SetOperationId', operationId);
  },
};

const mutations = {
  SetPartner(state, payload) {
    state.partner.name = payload;
  },
  SetSubscriptionId(state, payload) {
    state.subscriptionId = payload;
  },
  SetOperationId (state, payload) {
    state.operationId = payload;
  },
  SetUserAntheticated(state, payload) {
    state.authenticated = payload;
  },

  SetUserPremium(state, payload) {
    state.isPremium = payload;
  },

  SetUserToken(state, token) {
    state.token = token;
  },

  SetPartnerData(state, data) {
    state.partner.token = data.token;
    state.partner.name = data.name;
  },

  SaveUserName(state, name) {
    state.userName = name;
  },

  SaveUserId(state, id) {
    state.id = id;
  },

  SaveIsEmailFake(state, isEmailFake) {
    state.isEmailFake = isEmailFake;
  },

  SaveIsPromoAccepted(state, isPromoAccepted) {
    state.isPromoAccepted = isPromoAccepted;
  },

  SaveIsTcAccepted(state, isTcAccepted) {
    state.isTcAccepted = isTcAccepted;
  },

  SetStoreId(state, payload) {
    state.storeId = payload;
  },
};

const getters = {
  getSubscriptionId (state) {
    return state.subscriptionId;
  },
  getOperationId (state) {
    return state.operationId
  },
  getToken(state) {
    return state.token || localStorage.getItem('kidj_ut');
  },

  getAuthStatus(state) {
    return state.authenticated;
  },

  getPremium(state) {
    return state.isPremium;
  },

  getUserId(state) {
    return state.id;
  },

  getUserName(state) {
    return state.userName;
  },

  getIsEmailFake(state) {
    return state.isEmailFake;
  },

  getIsPromoAccepted(state) {
    return state.isPromoAccepted;
  },

  getIsTcAccepted(state) {
    return state.isTcAccepted;
  },

  getPartnerToken(state) {
    return state.partner.token;
  },

  getPartner(state) {
    return state.partner.name;
  },
  
  getStoreId(state) {
    return state.storeId;
  }
};

const namespaced = true;

export const account = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
